<template>
  <form>
    <validation-observer ref="formlivestream">
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="instruction-text">
            Select a research lab and click Start to start a live stream
            channel. The startup process takes approximately 1-2 minutes. Begin
            the Wirecast broadcast once the channel has started.
          </div>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="label">Choose Lab</label>
            <div class="control">
              <validation-provider v-slot="{ errors, failed }" rules="required">
                <div id="selectContainer" class="select">
                  <select v-model="selectedLiveStream">
                    <option
                      v-for="lab in availableLabs"
                      :key="lab.videoLiveStreamID"
                      :value="lab"
                    >
                      {{ lab.name }}
                    </option>
                  </select>
                </div>
                <span class="help is-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
        </div>
        <!--
        <div class="column is-12">
          <div class="field">
            <label class="label">Add Notes (optional)</label>
            <div class="control">
              <textarea v-model="model.description" class="input"></textarea>
            </div>
          </div>
        </div>
        -->
      </div>
      <div
        v-if="
          selectedLiveStreamInUse && !selectedLiveStreamInUseByCurrentProject
        "
        class="already-streaming-message"
      >
        <p>
          {{ selectedLiveStream.name }} is already streaming for project
          {{ selectedLiveStreamProjectName
          }}{{
            selectedLiveStreamInUseByDifferentOrganization
              ? ' in a different organization'
              : ''
          }}. Continuing will stop the live stream for project
          {{ selectedLiveStreamProjectName }} and start it for project
          {{ currentProjectName }}. Proceed?
        </p>
        <div class="approve-live-stream-start">
          <app-checkbox v-model="approvedLiveStreamStart" class="large">
            Stop streaming for project {{ selectedLiveStreamProjectName }} and
            start streaming for project {{ currentProjectName }}.
          </app-checkbox>
        </div>
      </div>
      <div
        v-else-if="
          selectedLiveStreamInUse && selectedLiveStreamInUseByCurrentProject
        "
        class="already-streaming-message"
      >
        <p>
          {{ selectedLiveStream.name }} is already
          streaming for project {{ selectedLiveStreamProjectName }}. Continuing
          will stop and restart the live stream. Proceed?
        </p>
        <div class="approve-live-stream-start">
          <app-checkbox v-model="approvedLiveStreamStart" class="large">
            Stop and restart live stream for project {{ currentProjectName }}.
          </app-checkbox>
        </div>
      </div>
      <div class="create-dialog-actions">
        <div
          class="button is-primary"
          :disabled="selectedLiveStreamInUse && !approvedLiveStreamStart"
          @click="
            !(selectedLiveStreamInUse && !approvedLiveStreamStart) &&
              handleStartLiveStream()
          "
        >
          Start
        </div>
      </div>
    </validation-observer>
  </form>
</template>

<script>
import Form from './Form.js';
import AppCheckbox from '../AppCheckbox';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import '@/validation.js';
import axios from 'axios';
import { CognitoIdentityCredentials, config, S3 } from 'aws-sdk';

// S3 properties
const bucketRegion = 'us-west-2';
const identityPoolId = 'us-west-2:cb03d30c-2a41-48ae-9e34-bb1898375c0f';

export default {
  name: 'LiveStreamForm',
  components: {
    ValidationProvider,
    ValidationObserver,
    AppCheckbox
  },
  extends: Form,
  props: ['availableLabs', 'projectId'],
  data() {
    return {
      selectedLiveStream: null,
      projects: null,
      approvedLiveStreamStart: false
    };
  },
  computed: {
    currentProjectName() {
      return this.projects.find(project => project.projectID === this.projectId)
        .name;
    },
    selectedLiveStreamProjectName() {
      let selectedLiveStreamProjectID = null;
      if (this.selectedLiveStream) {
        selectedLiveStreamProjectID = this.selectedLiveStream.projectID;
      }
      if (selectedLiveStreamProjectID !== null) {
        const selectedLiveStreamProject = this.projects.find(
          project => project.projectID === selectedLiveStreamProjectID
        );
        if (selectedLiveStreamProject !== null) {
          return selectedLiveStreamProject.name;
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    selectedLiveStreamInUse() {
      return this.selectedLiveStreamProjectName !== null;
    },
    selectedLiveStreamInUseByCurrentProject() {
      return this.selectedLiveStreamProjectName === this.currentProjectName;
    },
    selectedLiveStreamInUseByDifferentOrganization() {
      let isProjectInCurrentOrganization = false;
      this.$store.state.projects._items.forEach(project => {
        if (project.name === this.selectedLiveStreamProjectName) {
          isProjectInCurrentOrganization = true;
        }
      });
      return !isProjectInCurrentOrganization;
    }
  },
  watch: {
    active(newval, oldval) {
      if (newval != oldval && newval) {
        console.log('live stream form activated');
      }
    },
    selectedLiveStream() {
      this.approvedLiveStreamStart = false;
    }
  },
  mounted() {
    // Create an AWS Cognito identity pool with permissions to start a live stream
    config.update({
      region: bucketRegion,
      credentials: new CognitoIdentityCredentials({
        IdentityPoolId: identityPoolId
      })
    });
    // Fetch projects for all organizations
    this.axiosRequest('get', 'Projects').then(response => {
      this.projects = response.data;
    });
  },
  methods: {
    handleStartLiveStream() {
      console.log('starting a live stream');
      this.$refs.formlivestream.validate().then(success => {
        if (!success) {
          this.showErrorMessage('Please select a lab and try again');
          return;
        } else {
          if (this.selectedLiveStream != null) {
            // Start the selected live stream
            this.$emit('started', this.model);
            this.axiosRequest(
              'post',
              `Projects/${this.$route.params.projectID}/VideoLiveStreams/${this.selectedLiveStream.videoLiveStreamID}`
            )
              .then(response => {
                console.log(
                  'Live stream ' + this.selectedLiveStream.videoLiveStreamID + ' started'
                );
                console.log(response.data);
              })
              .catch(error => {
                this.showErrorMessage(error);
              });
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#selectContainer {
  max-width: 40%;
}

.instruction-text {
  opacity: 0.6;
  margin-bottom: 20px;
}

.already-streaming-message {
  color: white;
  margin-top: 35px;

  p {
    opacity: 0.6;
  }

  .approve-live-stream-start {
    color: white;
    opacity: 1;
    margin-top: 10px;
  }
}
</style>
